/* Finish an explicit opt-out only after Xcotton has saved it and removed its item. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  let intent = 0;
  let leaving = false;
  const protectedItem = item => item.handle === 'shipping-protection' || item.sku === 'XMHPACELSKU';
  const ready = (cart, contextId) => {
    const context = document.getElementById(contextId);
    const form = context?.querySelector(contextId === 'ajax-cart-drawer' ? 'form#cart' : '#mainCartForm');
    const terms = context?.querySelector('[data-cart-terms]');
    if (!form || !form.checkValidity() || terms && !terms.checked) return false;
    if (!cart.item_count || String(cart.attributes?.xcsp_confirm) !== '0' || cart.items.some(protectedItem)) return false;
    const note = context.querySelector('[data-cart-note]');
    if (note && note.value !== (cart.note || '')) return false;
    return [...form.querySelectorAll('[data-cart-item][data-variant]')].every(row => {
      if (!row.getClientRects().length) return true;
      const item = cart.items.find(item => String(item.variant_id) === row.dataset.variant);
      const inputs = [...row.querySelectorAll('input[name="updates[]"]')].filter(input => !input.disabled && input.getClientRects().length);
      return !inputs.length || item && inputs.every(input => Number(input.value) === item.quantity);
    });
  };
  document.addEventListener('click', event => {
    const optOut = event.target.closest?.('[data-xmh-checkout-without="true"]');
    const context = optOut?.closest('#ajax-cart-drawer') || optOut?.closest('#MainContent');
    if (!context) {
      if (event.isTrusted) intent += 1;
      return;
    }
    const current = ++intent;
    const contextId = context.id;
    let attempts = 0;
    const check = async () => {
      if (leaving || current !== intent || !document.getElementById(contextId)) return;
      try {
        const response = await fetch(root + 'cart.js?bestek_checkout_check=' + Date.now(), {cache: 'no-store'});
        if (!response.ok) return;
        const cart = await response.json();
        if (leaving || current !== intent) return;
        if (ready(cart, contextId)) {
          leaving = true;
          window.location.assign(root + 'checkout');
          return;
        }
        if (++attempts < 8) setTimeout(check, 750);
      } catch (_error) {
        // Leave the existing cart and SDK controls available when confirmation fails.
      }
    };
    setTimeout(check, 1200);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.id === 'mainCartForm' || event.target.id === 'cart') intent += 1;
  }, true);
  window.addEventListener('pagehide', () => { leaving = true; intent += 1; });
})();
